import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  theme?: 'light' | 'dark';
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Loading...",
  className,
  size = 'md',
  theme = 'light',
  fullScreen = true
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const textColor = theme === 'dark' ? 'text-white' : 'text-muted-foreground';

  const baseClasses = "flex flex-col items-center justify-center gap-4";
  const containerClasses = fullScreen 
    ? cn(baseClasses, "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm", className)
    : cn(baseClasses, className);

  return (
    <div className={containerClasses}>
      <div className={cn(
        "border-4 border-t-transparent border-primary rounded-full animate-spin",
        sizeClasses[size]
      )}></div>
      <span className={textColor}>{message}</span>
    </div>
  );
};

export default LoadingSpinner;